module.exports = __webpack_public_path__ + "img/epbanner.c8161def.png";